import { Component, Input, Output, EventEmitter, HostListener, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { CfCoreGalleryHelperService } from './cf-core-gallery-helper.service';
export class CfCoreGalleryThumbnailsComponent implements OnChanges {

    thumbnailsLeft: string;
    mouseenter: boolean;

     images: string[];
     columns: number;
     rows: number;
     arrows: boolean;
     arrowsAutoHide: boolean;
     margin: number;
     selectedIndex: number;
     clickable: boolean;
     swipe: boolean;

     onActiveChange = new EventEmitter();
private index = 0;
/**
 * @param {?} sanitization
 * @param {?} elementRef
 * @param {?} helperService
 */
constructor(private sanitization: DomSanitizer,
private elementRef: ElementRef,
private helperService: CfCoreGalleryHelperService) {}
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        if (changes['images']) {
            this.selectedIndex = 0;
            this.index = 0;
        }

        if (changes['selectedIndex']) {
            this.validateIndex();
        }

        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef,
            'thumbnails', () => this.moveRight(), () => this.moveLeft());
        }
    }
/**
 * @return {?}
 */
onMouseEnter() {
        this.mouseenter = true;
    }
/**
 * @return {?}
 */
onMouseLeave() {
        this.mouseenter = false;
    }
/**
 * @return {?}
 */
onResize() {
        this.setDefaultPosition();
    }
/**
 * @param {?} event
 * @param {?} index
 * @return {?}
 */
handleClick(event: Event, index: number): void {
        this.selectedIndex = index;
        this.onActiveChange.emit(index);

        event.stopPropagation();
        event.preventDefault();
    }
/**
 * @return {?}
 */
moveRight(): void {
        if (this.canMoveRight()) {
            this.index++;
            this.setThumbnailsPosition();
        }
    }
/**
 * @return {?}
 */
moveLeft(): void {
        if (this.canMoveLeft()) {
            this.index--;
            this.setThumbnailsPosition();
        }
    }
/**
 * @return {?}
 */
canMoveRight(): boolean {
        return this.index + this.columns < this.getMaxIndex() ? true : false;
    }
/**
 * @return {?}
 */
canMoveLeft(): boolean {
        return this.index !== 0 ? true : false;
    }
/**
 * @param {?} index
 * @return {?}
 */
getThumbnailLeft(index: number): SafeStyle {
        const /** @type {?} */ calculatedIndex = Math.floor(index / this.rows);
        return this.getThumbnailPosition(calculatedIndex, this.columns);
    }
/**
 * @param {?} index
 * @return {?}
 */
getThumbnailTop(index: number): SafeStyle {
        const /** @type {?} */ calculatedIndex = index % this.rows;
        return this.getThumbnailPosition(calculatedIndex, this.rows);
    }
/**
 * @return {?}
 */
getThumbnailWidth(): SafeStyle {
        return this.getThumbnailDimension(this.columns);
    }
/**
 * @return {?}
 */
getThumbnailHeight(): SafeStyle {
        return this.getThumbnailDimension(this.rows);
    }
/**
 * @return {?}
 */
setThumbnailsPosition(): void {
        this.thumbnailsLeft = 'calc(-' + ((100 / this.columns) * this.index)
            + '% - ' + ((this.margin - (((this.columns - 1)
            * this.margin) / this.columns)) * this.index) + 'px)';
    }
/**
 * @return {?}
 */
setDefaultPosition(): void {
        this.thumbnailsLeft = '0px';
    }
/**
 * @return {?}
 */
canShowArrows(): boolean {
        if (this.arrows && this.images && this.images.length > this.getVisibleCount()
            && (!this.arrowsAutoHide || this.mouseenter)) {
            return true;
        } else {
            return false;
        }
    }
/**
 * @return {?}
 */
validateIndex(): void {
        const /** @type {?} */ newIndex = Math.floor(this.selectedIndex / this.rows);

        if (newIndex < this.index || newIndex >= this.index + this.columns) {
            const /** @type {?} */ maxIndex = this.getMaxIndex() - this.columns;
            this.index = newIndex > maxIndex ? maxIndex : newIndex;

            this.setThumbnailsPosition();
        }
    }
/**
 * @param {?} index
 * @param {?} count
 * @return {?}
 */
private getThumbnailPosition(index: number, count: number): SafeStyle {
        return this.getSafeStyle('calc(' + ((100 / count) * index) + '% + '
            + ((this.margin - (((count - 1) * this.margin) / count)) * index) + 'px)');
    }
/**
 * @param {?} count
 * @return {?}
 */
private getThumbnailDimension(count: number): SafeStyle {
        if (this.margin !== 0) {
            return this.getSafeStyle('calc(' + (100 / count) + '% - '
                + (((count - 1) * this.margin) / count) + 'px)');
        } else {
            return this.getSafeStyle('calc(' + (100 / count) + '% + 1px)');
        }
    }
/**
 * @return {?}
 */
private getMaxIndex(): number {
        return Math.ceil(this.images.length / this.rows);
    }
/**
 * @return {?}
 */
private getVisibleCount(): number {
        return this.columns * this.rows;
    }
/**
 * @param {?} value
 * @return {?}
 */
private getSafeStyle(value: string): SafeStyle {
        return this.sanitization.bypassSecurityTrustStyle(value);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cf-core-gallery-thumbnails',
    template: "<div class=\"cf-core-gallery-thumbnails-wrapper\"> <div class=\"cf-core-gallery-thumbnails\" [style.left]=\"thumbnailsLeft\"> <div class=\"cf-core-gallery-thumbnail\" *ngFor=\"let image of images; let i = index;\" [style.background-image]=\"'url(' + image + ')'\" (click)=\"handleClick($event, i)\" [style.width]=\"getThumbnailWidth()\" [style.height]=\"getThumbnailHeight()\" [style.left]=\"getThumbnailLeft(i)\" [style.top]=\"getThumbnailTop(i)\" [ngClass]=\"{ 'cf-core-gallery-active': i == selectedIndex, 'cf-core-gallery-clickable': clickable }\"></div> </div> </div> <cf-core-gallery-arrows *ngIf=\"canShowArrows()\" (onPrevClick)=\"moveLeft()\" (onNextClick)=\"moveRight()\" [prevDisabled]=\"!canMoveLeft()\" [nextDisabled]=\"!canMoveRight()\"></cf-core-gallery-arrows> ",
    styles: [":host { width: 100%; display: inline-block; position: relative; } .cf-core-gallery-thumbnails-wrapper { width: 100%; height: 100%; position: absolute; overflow: hidden; } .cf-core-gallery-thumbnails { height: 100%; width: 100%; position: absolute; left: 0px; transition: left 0.5s ease-in-out; } .cf-core-gallery-thumbnails .cf-core-gallery-thumbnail { position: absolute; height: 100%; background-size: cover; background-position: center; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomSanitizer, },
{type: ElementRef, },
{type: CfCoreGalleryHelperService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'images': [{ type: Input },],
'columns': [{ type: Input },],
'rows': [{ type: Input },],
'arrows': [{ type: Input },],
'arrowsAutoHide': [{ type: Input },],
'margin': [{ type: Input },],
'selectedIndex': [{ type: Input },],
'clickable': [{ type: Input },],
'swipe': [{ type: Input },],
'onActiveChange': [{ type: Output },],
'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ] },],
'onMouseLeave': [{ type: HostListener, args: ['mouseleave', ] },],
'onResize': [{ type: HostListener, args: ['window:resize', ] },],
};
}

function CfCoreGalleryThumbnailsComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryThumbnailsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreGalleryThumbnailsComponent.ctorParameters;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.propDecorators;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.thumbnailsLeft;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.mouseenter;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.images;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.columns;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.rows;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.arrows;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.arrowsAutoHide;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.margin;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.selectedIndex;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.clickable;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.swipe;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.onActiveChange;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.index;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.sanitization;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.elementRef;
/** @type {?} */
CfCoreGalleryThumbnailsComponent.prototype.helperService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
